import { Grid, Paper, Typography, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { colorTheme } from 'theme';
import { FOOTER_COPYRIGHTS_TEXT } from '../utils/Constants';

const AuthLayouts = (): JSX.Element => {
  const theme = useTheme();
  const colors = colorTheme(theme.palette.mode);
  const styles = {
    paperContainer: {
      backgroundSize: 'cover',
      backgroundColor: colors.greenAccent[500],
      height: '100vh',
      width: '100vw',
    },
    mainGrid: {
      minHeight: '100vh',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      paddingTop: '33px',
    },
    outLetGrid: {
      px: 15,
      paddingBottom: 10,
      width: 700,
      borderRadius: 2,
      boxShadow: 4,
      maxWidth: 'none !important',
      bgcolor: colors.primaryBg[900],
    },
    footerMainGrid: {
      width: 700,
      textAlign: 'center',
      justifyContent: 'center',
    },
    footerTyphoGrid: {
      textAlign: 'center',
      justifyContent: 'center',
    },
    footerTypho: {
      textAlign: 'center',
      justifyContent: 'center',
      color: colors.primaryBg[900],
    },
    footerRightGrid: {
      textAlign: 'right',
    },
  };

  return (
    <Paper style={styles.paperContainer}>
      <Grid container spacing={0} style={styles.mainGrid}>
        <Grid item xs={3} sx={styles.outLetGrid}>
          <Outlet />
        </Grid>

        <Grid container mt={1.5} sx={styles.footerMainGrid}>
          <Grid item xs={12} sm={12} md={6} xl={6} sx={styles.footerTyphoGrid}>
            <Typography component="h2" variant="h5" sx={styles.footerTypho}>
              {FOOTER_COPYRIGHTS_TEXT}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default AuthLayouts;
